import { useAppTranslation } from "@/i18n/useAppTranslation";
import { cn } from "@/lib/utils";

export function DashboardMessageBadge({ count, className }: { count: number; className?: string }) {
  const { t } = useAppTranslation();
  if (count <= 0) return null;
  return (
    <>
      <span className="sr-only">
        {`, ${t("nav.unread_indicator_aria", { count })}`}
      </span>
      <span
        aria-hidden="true"
        className={cn("ml-auto flex h-4 min-w-4 shrink-0 items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-bold leading-none text-white", className)}
      >
        {count > 9 ? "9+" : count}
      </span>
    </>
  );
}
